import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import MasterRider from "./views/page";
import { RouterProvider, createBrowserRouter } from "react-router-dom";

const routes = [
  {
    path: "*",
    element: <MasterRider />,
    extract: true,
  },
  {
    path: "*",
    element: <div></div>,
    extract: true,
  },
];

const router = createBrowserRouter(routes);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RouterProvider router={router} />);

reportWebVitals();
